module.exports = __webpack_public_path__ + "static/media/woods_headshot.3f913efa.png";